import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import { googleAnalyticsId } from '../_config/config'
import router from '../router'

Vue.use(VueAnalytics, {
  id: googleAnalyticsId,
  router,
  disabled: false
})
